import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StatusButton from './StatusButton';

const Campaign = ({ onPreview, campaignName }) => (
  <Container onClick={onPreview}>
    <StatusButton
      style={{ width: 15, height: 15 }}
      url="/images/preview.png"
    />
    <Label>{campaignName}</Label>
  </Container>
);

export default Campaign;

Campaign.propTypes = {
  onPreview: PropTypes.func.isRequired,
  campaignName: PropTypes.string.isRequired,
};

const Container = styled.div`
  cursor: pointer;
  display: flex;
  border: 1px solid #7a7e93;
  border-radius: 25px;
  background-color: white;
  padding: 2px;
  margin: 2px;
`;

const Label = styled.div`
  font-size: 12px;
  font-family: 'Karla', sans-serif;
  margin-left: 5px;
  margin-right: 5px;
  color: #7a7e93;
  max-width: 50px;
  overflow: hidden;
`;




// WEBPACK FOOTER //
// ./client/Dashboard/components/Campaign.js